import { BlockOverrides, BlockProps } from 'baseui/block';
import { Typography } from 'baseui/themes';
import { DisplayLarge } from 'baseui/typography';
import mediaQuery from 'common/styles/styles.breakpoint';
import typography from 'common/styles/styles.typography';
import { themedUseStyletron } from 'common/styles/styletron.theme';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';
import merge from 'ts-deepmerge';

type MediaQueryType = keyof typeof mediaQuery | 'initial';
interface Props extends Omit<BlockProps, 'color'> {
  variant:
    | (keyof Typography | keyof typeof typography)
    | Partial<
        Record<MediaQueryType, keyof Typography | keyof typeof typography>
      >;
  color?: string;
  $style?: StyleObject | any;
  textAlign?: React.CSSProperties['textAlign'];
}
function Text(props: Props, ref) {
  const { variant, ...rest } = props;
  const [, theme] = themedUseStyletron();

  const boldFont = (
    textVariant: keyof Typography | keyof typeof typography,
  ) => {
    if (typeof variant === 'string') {
      const check = ['Label', 'Heading', 'Display'].some((curr) =>
        textVariant.includes(curr),
      );
      if (check) {
        return {
          fontWeight: '500',
        };
      }
    }
    return {};
  };

  const overrides = merge(
    {
      Block: {
        style: {
          color: props.color || theme.colors.inkDark,
          textAlign: props.textAlign,
          ...(typeof variant === 'string'
            ? {
                ...theme.typography[variant],
                ...boldFont(variant),
              }
            : {
                ...Object.keys(variant)?.reduce((prev, next) => {
                  return {
                    ...prev,
                    ...(next === 'initial'
                      ? {
                          ...theme.typography[variant[next]!],
                          ...boldFont(next as any),
                        }
                      : {
                          [theme.mediaQuery[next]]: {
                            ...theme.typography[variant[next]],
                            ...boldFont(next as any),
                          },
                        }),
                  };
                }, {}),
              }),
          ...props.$style,
        },
      },
    } as BlockOverrides,
    { ...props.overrides },
  );
  return <DisplayLarge {...rest} overrides={overrides} ref={ref} />;
}

export default React.forwardRef(Text);
